var _circle, _path, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 26.7085C10.5 24.5021 10.5 23.3988 10.8051 22.5103C11.3688 20.869 12.6583 19.5796 14.2996 19.0159C15.1881 18.7108 16.2913 18.7108 18.4978 18.7108H19.6446C21.4135 18.7108 22.298 18.7108 23.0321 18.8645C25.8469 19.4539 28.0461 21.6531 28.6355 24.4679C28.7893 25.2021 28.7893 26.0865 28.7893 27.8554C28.7893 29.6243 28.7893 30.5087 28.6355 31.2429C28.0461 34.0576 25.8469 36.2569 23.0321 36.8463C22.298 37 21.4135 37 19.6446 37C17.8757 37 16.9913 37 16.2572 36.8463C13.4424 36.2569 11.2432 34.0576 10.6537 31.2429C10.5 30.5087 10.5 29.6243 10.5 27.8554V26.7085Z",
    fill: "#CFA809"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0257,
    cy: 25.7491,
    r: 2.58621,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.2153 14.8668C25.7489 14.7104 25.252 14.9612 25.1048 15.4289C24.962 15.8958 25.224 16.4019 25.6897 16.5575C26.9868 16.992 28.2366 17.9344 29.2106 19.2123C30.1841 20.4895 30.7621 21.9452 30.8373 23.311C30.8639 23.8013 31.2824 24.1881 31.7712 24.1735C31.953 24.1669 32.1248 24.1057 32.2669 23.9974C32.4961 23.8227 32.6223 23.5443 32.6068 23.2523C32.512 21.5278 31.8028 19.7145 30.6081 18.1471C29.4135 16.5798 27.853 15.4153 26.2153 14.8668Z",
    fill: "#CFA809"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M26.8594 10.7193C26.3952 10.5625 25.8954 10.8129 25.7496 11.2808C25.6068 11.7477 25.8688 12.2538 26.3338 12.41C28.5275 13.1448 30.6374 14.7319 32.2733 16.8782C33.9098 19.0252 34.8809 21.4804 35.008 23.7904C35.0359 24.281 35.4538 24.6669 35.9427 24.6524C36.1245 24.6457 36.2955 24.5851 36.4376 24.4768C36.6668 24.3021 36.7938 24.0231 36.7775 23.7317C36.6317 21.0625 35.5285 18.2503 33.6708 15.813C31.8143 13.3773 29.3945 11.5674 26.8594 10.7193Z",
    fill: "#CFA809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceWithBg);
export default __webpack_public_path__ + "static/media/device-with-bg.4465c237894e53a86fd03021f4c4d839.svg";
export { ForwardRef as ReactComponent };